module.exports = __webpack_public_path__ + "static/media/cupcakeChocolate.9d0689b1.jpg";